import React from 'react';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import TableShowData from '@/pages/intelligence/components/TableComponents/components/TableShowData';
import { valueFormat, growthFormat } from '@/pages/intelligence/utils/commonUtils';
import { useIntl, getLocale } from 'umi';
import { LANGUAGE_CN } from '@/pages/intelligence/_config/config';

// 带小数点格式的值
const VALUE_TYPE = 'pointValue';
// 绝对值小于1带小数点
const POINT_COND = 'lessThanOne';
// 小数点位数
const DECIMAL = 2;
// 最大值，超过这个值会展示 MAX+%
const MAX = 9999;
const DEFAULT_WIDTH = 180;
const DEFAULT_ALIGN = 'center';

interface metricsContentItf {
  metric: string;
  metricCN: string;
  value: number;
  dod: string;
  width?: number | string;
  isDodHide?: boolean;
  onTextClick?: (text: string) => void;
  isTextCanBeClick?: boolean;
}

export default function MetricsContent(props: metricsContentItf) {
  const { metric, metricCN, value, dod, isDodHide = true, width = DEFAULT_WIDTH, onTextClick, isTextCanBeClick = false } = props;

  const locale = getLocale();
  const isCN = locale === LANGUAGE_CN;

  // 转换数值为BMK
  const formattedValue = valueFormat(value);

  // 转换环比数据为带颜色和箭头的形式
  const { type, value: dodValue } = growthFormat({
    value: dod,
    valueType: VALUE_TYPE,
    hasPoint: POINT_COND,
    fixedNum: DECIMAL,
    maxNumber: MAX,
  });

  return (
    <CloumsCenter width={width} align={DEFAULT_ALIGN}>
      <TableShowData
        maxNumber={`${MAX}+%`}
        text={(isCN ? metricCN : metric) || metric}
        separator={':'}
        value={formattedValue}
        type={type}
        growth={dodValue}
        isDodHide={isDodHide}
        isTextCanBeClick={isTextCanBeClick}
        onTextClick={onTextClick}
      />
    </CloumsCenter>
  );
}
